import { Box, CircularProgress } from "@mui/material"
import type { ReactNode } from "react"

const TextLineWithSpinner = ({ loading, children }: { loading: boolean; children: ReactNode }): ReactNode | string => {
  return loading ? (
    <Box className='flex items-center'>
      <CircularProgress size={16} />
    </Box>
  ) : (
    children
  )
}
export default TextLineWithSpinner
